import { isDefined } from "@clipboard-health/util-ts";
import { Alert, IconButton, Stack, Switch, Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { useLoadEtpSettings } from "src/containers/contractTerms/extraTimePayV2/hooks/useLoadEtpSettings";
import { useSaveEtpSettings } from "src/containers/contractTerms/extraTimePayV2/hooks/useSaveEtpSettings";
import { SessionType } from "src/modules/interface";
import InfoIcon from "@mui/icons-material/Info";
import { EMPLOYEE_ROLES } from "@src/appV2/Employee/constants";
import { Text } from "@src/lib/ui-react";

export function ExtraTimePayEditAccessSwitch() {
  const {
    adminProfile,
    profile: { userId: facilityId },
  } = useSelector((state: SessionType) => state.session);
  const { data: settings, isLoading } = useLoadEtpSettings(facilityId);
  const { mutateAsync: saveEtpSettings, isLoading: isSaving } = useSaveEtpSettings(facilityId);

  if (isLoading) {
    return <Alert severity="info">Loading the workplace Extra Time Pay settings...</Alert>;
  }

  if (!isDefined(settings)) {
    return <Alert severity="error">Unable to load the workplace Extra Time Pay settings</Alert>;
  }

  return (
    <Stack>
      <Text variant="body2" bold>
        Extra Time Pay
      </Text>
      <Stack direction="row" alignItems="center" sx={{ paddingLeft: 1 }}>
        <Text variant="body2">Allow workplace to update Extra Time Pay in the app</Text>
        <Switch
          checked={settings.isEditableByFacility}
          onChange={(_event, checked) => {
            void saveEtpSettings({
              updatedSettings: { isEditableByFacility: checked },
              previousSettings: settings,
            });
          }}
          disabled={!adminProfile?.roles?.includes(EMPLOYEE_ROLES.EXTRA_TIME_PAY) || isSaving}
        />
        <Tooltip
          arrow
          placement="top"
          title={
            <Text variant="caption">
              Enabling this toggle allows the workplace to update their Extra Time Pay settings in
              the workplace app. Disabling this toggle requires a workplace to contact Clipboard
              Health to make any changes to Extra Time Pay.
            </Text>
          }
        >
          <IconButton>
            <InfoIcon color="primary"></InfoIcon>
          </IconButton>
        </Tooltip>
      </Stack>
    </Stack>
  );
}
